(() => {
  class WFStickyNav {
    constructor() {
      this.header = document.querySelector('#header .header-navigation');

      window.addEventListener('scroll', this.onScroll.bind(this));
      window.addEventListener('load', this.onScroll.bind(this));
    }

    onScroll() {
      if ((isNaN(this.lastPos) || this.lastPos < window.scrollY) && window.scrollY > 0) {
        this.header.classList.add('hidden');
      } else {
        this.header.classList.remove('hidden');
      }
      if (window.scrollY > 0) {
        this.header.classList.remove('at-top');
      } else {
        this.header.classList.add('at-top');
      }
      this.lastPos = window.scrollY;
    }
  }
  document.addEventListener('DOMContentLoaded', () => {
    if (document.querySelector('#header .header-navigation')) {
      let stickynav = new WFStickyNav();
    }
  })
})();